// @flow
/* eslint-disable import/prefer-default-export */
// $FlowFixMe
import type { UseMutationResult } from "@tanstack/react-query";
import { useMutation } from "@tanstack/react-query";
import { QUERIES } from "@/enums/queries";
import type { ExportCreateProps, ExportProps } from "types/exports";

import { addExport } from "./services/mutateExports";
import { invalidateLoadExports } from "./useLoadExports";

type Props = {
  addExport: (data: ExportCreateProps) => Promise<ExportProps>,
  isLoading: boolean,
} & UseMutationResult<ExportProps, Error>;

export const useAddExports = (
  options: any = {},
  // $FlowFixMe
): Props => {
  const mutation = useMutation({
    mutationKey: [QUERIES.EXPORTS.ADD],
    mutationFn: async (data: ExportCreateProps) => await addExport(data),
    onSuccess: () => {
      invalidateLoadExports();
    },
    ...options,
  });

  const addExportReq = async (data: ExportCreateProps) => {
    return mutation.mutateAsync(data);
  };

  return {
    addExport: addExportReq,
    ...mutation,
  };
};
